const getMethodPayment = ({ amountCOD, isCod }) => {
  if (isCod === 0) return "پیشکرایه";

  if (amountCOD === 0) return "پسکرایه";
  return "پرداخت در محل-COD";
};

export default getMethodPayment;
